import { render } from "./UserTopCardCells.vue?vue&type=template&id=523bec67&scoped=true"
import script from "./UserTopCardCells.vue?vue&type=script&lang=js"
export * from "./UserTopCardCells.vue?vue&type=script&lang=js"

import "./UserTopCardCells.vue?vue&type=style&index=0&id=523bec67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523bec67"],['__file',"src/components/UserTopCardCells.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "523bec67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('523bec67', __exports__)) {
    api.reload('523bec67', __exports__)
  }
  
  module.hot.accept("./UserTopCardCells.vue?vue&type=template&id=523bec67&scoped=true", () => {
    api.rerender('523bec67', render)
  })

}


export default __exports__